// src/context/AppContext.js
import React, { createContext, useState, useEffect, useRef } from 'react';
import { getAssetUrl } from '../api/config';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
    // Stati esistenti
    const [textAndAudio, setTextAndAudio] = useState(() => {
        const saved = localStorage.getItem('textAndAudio');
        return saved === null ? true : JSON.parse(saved);
    });

    const [bgMusicVolume, setBgMusicVolume] = useState(() => {
        const saved = localStorage.getItem('bgMusicVolume');
        return saved === null ? 0.1 : parseFloat(saved);
    });

    const [dbType, setDbType] = useState(() => {
        const saved = localStorage.getItem('dbType');
        return saved || 'local';
    });
    
    // Riferimento globale all'oggetto Audio della musica di sottofondo
    const bgMusicRef = useRef(null);

    // Inizializza l'audio una sola volta
    useEffect(() => {
        const music = new Audio(getAssetUrl('/audios/storyline/it/musichetta.wav'));
        music.loop = true;
        music.volume = bgMusicVolume;
        bgMusicRef.current = music;

        return () => {
            if (bgMusicRef.current) {
                bgMusicRef.current.pause();
                bgMusicRef.current = null;
            }
        };
    }, []);

    // Aggiorna il volume globalmente ogni volta che cambia bgMusicVolume
    useEffect(() => {
        if (bgMusicRef.current) {
            bgMusicRef.current.volume = bgMusicVolume;
        }
    }, [bgMusicVolume]);

    // Funzione per far partire la musica (chiamata da Home o interazioni)
    const startBgMusic = () => {
        if (bgMusicRef.current && bgMusicRef.current.paused) {
            bgMusicRef.current.play().catch(e => console.log("Autoplay bloccato, in attesa di interazione"));
        }
    };

    const stopBgMusic = () => {
        if (bgMusicRef.current) {
            bgMusicRef.current.pause();
        }
    };

    // Derive enableText e enableAudio dal toggle
    const enableText = textAndAudio;
    const enableAudio = true;
    
    // Persist settings to localStorage
    useEffect(() => {
        localStorage.setItem('textAndAudio', JSON.stringify(textAndAudio));
    }, [textAndAudio]);

    useEffect(() => {
        localStorage.setItem('bgMusicVolume', bgMusicVolume.toString());
    }, [bgMusicVolume]);

    useEffect(() => {
        localStorage.setItem('dbType', dbType);
    }, [dbType]);
    
    return (
        <AppContext.Provider value={{
            enableText,
            enableAudio,
            textAndAudio,
            setTextAndAudio,
            bgMusicVolume,
            setBgMusicVolume,
            dbType,
            setDbType,
            startBgMusic,
            stopBgMusic,
            setEnableText: (value) => setTextAndAudio(value),
            setEnableAudio: () => {},
        }}>
            {children}
        </AppContext.Provider>
    );
};
